import { useCallback, useState } from 'react'
import { useMounted } from '../../../Hooks/useMounted'
import { LabContactSchema } from '../../../Schema/LabContactSchema'
import { useAppDispatch } from '../../../Hooks/useAppDispatch'
import { LabContactsActions } from '../StoreAdapter'
import { LabContactsAPI } from '../../../Services/API/LabContactsAPI'
import { ServiceLocator } from '../../../Services/ServiceLocator'

export const useUpdateLabContact = () => {
  const dispatch = useAppDispatch()
  const mounted = useMounted()

  const [processing, setProcessing] = useState(false)
  const [errors, setErrors] = useState<
    Record<string, string> | Record<string, string>[]
  >(null)
  const [errorMessage, setErrorMessage] = useState<string>(null)

  const updateLabContact = useCallback(
    async (schema: LabContactSchema): Promise<LabContactSchema> => {
      setProcessing(true)
      return ServiceLocator.resolve(LabContactsAPI)
        .updateEntity(schema)
        .then((schema) => {
          dispatch(LabContactsActions.updateOne(schema))
          if (mounted.current) {
            setProcessing(false)
            setErrors(null)
            setErrorMessage(null)
          }
          return schema
        })
        .catch((err) => {
          if (mounted.current) {
            setProcessing(false)
            setErrorMessage(err?.response?.data?.errorMessage)
            setErrors(err?.response?.data?.errors)
            throw err
          }
          return null
        })
    },
    [dispatch, mounted],
  )

  return {
    processing,
    errors,
    errorMessage,
    updateLabContact,
  }
}
